import useSuspendableQuery from 'hooks/useSuspendableQuery';
import { useParams } from 'react-router';
import {
  GetCoursesCollectionDocument,
  GetCoursesCollectionQuery,
  GetCoursesCollectionQueryVariables,
} from '__generated__/graphql';

interface UseCoursesCollectionResult {
  data: GetCoursesCollectionQuery | undefined;
  error: Error | undefined;
}

export function useCoursesCollection(): UseCoursesCollectionResult {
  const { slug } = useParams<{ slug: string }>();

  const { data, error } = useSuspendableQuery<
    GetCoursesCollectionQuery,
    GetCoursesCollectionQueryVariables
  >(GetCoursesCollectionDocument, {
    variables: {
      slug,
    },
    fetchPolicy: 'network-only',
  });
  return { data, error };
}
